<template>
    <el-upload
            class="upload-demo"
            action="url"
            :on-change="handleChange"
            :on-remove="fileRemove"
            :before-upload="beforeUploadHandle"
            :on-success="successHandle"
            :file-list="fileList">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
    </el-upload>
</template>
<script>
export default {
  data () {
    return {
      url: '/oss/file/upload2',
      fileList: [{
        id: '',
        fileName: '',
        fileType: '',
        size: '',
        url: ''
      }]
    }
  },
  methods: {
    handleChange (file, fileList) {
      this.fileList = fileList.slice(-3)
    },
    // 上传之前
    beforeUploadHandle (file) {
      if (file.size / 1024 / 1024 > 30) { this.$message.error('文件太大，只能上传30MB以内的文件'); return false }
      this.num++
    },
    fileRemove (file) {
      this.fileList = this.fileList.reduce((total, current) => {
        current.id !== file.id && total.push(current)
        return total
      }, [])
    },
    // 上传成功
    successHandle (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.fileList = fileList
      this.num--
      if (this.num === 0) {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
            this.$emit('refreshDataList')
          }
        })
      }
    }
  }
}
</script>
